const COMPETITOR_ANALYSIS_FEATURE = "competitor_analysis_view";
const DESIGN_AUTHORITY_FEATURE = "design_authority";

export function orderPlanNavigationFeatures(featureIds = []) {
  if (!Array.isArray(featureIds) || !featureIds.includes(DESIGN_AUTHORITY_FEATURE)) {
    return Array.isArray(featureIds) ? [...featureIds] : [];
  }

  const ordered = featureIds.filter(
    (featureId) => featureId !== DESIGN_AUTHORITY_FEATURE,
  );
  const competitorIndex = ordered.indexOf(COMPETITOR_ANALYSIS_FEATURE);

  if (competitorIndex === -1) {
    ordered.push(DESIGN_AUTHORITY_FEATURE);
  } else {
    ordered.splice(competitorIndex + 1, 0, DESIGN_AUTHORITY_FEATURE);
  }

  return ordered;
}

